import { useCallback, useEffect, useState } from 'react';
import { buildingsApi } from '../api/buildings';

export function useBuildingMeta(buildingId?: string | null) {
  const [meta, setMeta] = useState<any | null>(null);
  const [reloadToken, setReloadToken] = useState(0);

  const reload = useCallback(() => {
    setReloadToken((prev) => prev + 1);
  }, []);

  useEffect(() => {
    let ignore = false;
    if (!buildingId) {
      setMeta(null);
      return () => {
        ignore = true;
      };
    }

    (async () => {
      try {
        const data = await buildingsApi.getBuildingById(String(buildingId));
        if (!ignore) setMeta(data);
      } catch (error) {
        if (!ignore) setMeta(null);
      }
    })();

    return () => {
      ignore = true;
    };
  }, [buildingId, reloadToken]);

  return { meta, reload };
}
